(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Horizon updates Collection filters and sorting with pushState. A full
  // Collection render on browser history navigation keeps the URL, controls,
  // result count, and product grid in agreement without changing shared facets.
  window.addEventListener('popstate', () => window.location.reload());

  } catch(e) { console.error(e); }
})();
})();
